module.exports = __webpack_public_path__ + "static/media/5-ball.d14c4d22.png";